import PropTypes from 'prop-types';
import FormGroup from 'components/FormGroup';
import GlobalContext from 'contexts';
import useFetchData from 'hooks/useFetchData';
import { useContext } from 'react';
import Api from 'utils/api';
import moment from 'moment/moment';

export function GeneralMedicalSummery(props) {
  const { closeDrawer } = props;
  const { currentProduct } = useContext(GlobalContext);

  const { data: medicalSummery } = useFetchData(
    `client-prediabetes-measures/getMedicalSummery/${currentProduct.client_product_uuid}/false`
  );

  const thisSummary = medicalSummery?.summery;

  const fields = [
    {
      name: 'value',
      label: 'סיכום',
      required: true,
      type: 'textarea',
      breakLine: true,
      default: thisSummary
    }
  ];

  const onSubmit = (data) => {
    Api.post(
      `/client-prediabetes-measures/medicalSummery/${currentProduct.client_product_uuid}`,
      data
    ).then(() => {
      closeDrawer();
    });
  };

  return (
    <div>
      <div>
        סיכום פגישה
        {medicalSummery?.value && medicalSummery?.lastUpdated && (
          <span>
            {' '}
            נכתב ב־
            {moment(medicalSummery.lastUpdated).format('DD.MM.YYYY HH:mm')}
          </span>
        )}
      </div>
      {medicalSummery && (
        <>
          <FormGroup
            fields={fields}
            data={medicalSummery}
            onSubmit={onSubmit}
          ></FormGroup>
          {medicalSummery?.value && (
            <span>נכתב ע"י {medicalSummery.updatedBy}</span>
          )}
        </>
      )}
    </div>
  );
}

GeneralMedicalSummery.propTypes = {
  closeDrawer: PropTypes.func.isRequired
};
